import React from 'react';
import Player from '../components/Player';
import { usePlayer } from '../context/PlayerContext';

export default function Listen() {
  const { nowPlaying } = usePlayer();
  return (
    <section className="w-full flex flex-col items-center text-center fade-up">
      <div className="text-[10px] font-mono-r tracking-[0.5em] uppercase opacity-70">
        ::  Live Stream  ::
      </div>
      <h1 className="font-display text-6xl md:text-8xl mt-4">LISTEN LIVE</h1>
      <p className="font-mono-r text-xs md:text-sm tracking-[0.25em] uppercase opacity-70 mt-3">
        24 / 7 · MP3 · {nowPlaying.bitrate} kbps
      </p>

      <div className="ascii-divider my-10">─  ─  ─  ─  ─</div>

      {/* Rotating record visual */}
      <div className="relative w-56 h-56 md:w-72 md:h-72 mb-10 flex items-center justify-center">
        <div className={`absolute inset-0 hairline rounded-full ${nowPlaying ? 'slow-spin' : ''}`} />
        <div className="absolute inset-6 rounded-full border border-white opacity-50" />
        <div className="absolute inset-14 rounded-full border border-white opacity-30" />
        <div className="absolute inset-24 rounded-full border border-white opacity-20" />
        <div className="absolute w-3 h-3 bg-black rounded-full" />
      </div>

      <Player size="lg" />

      {/* Also On: TuneIn */}
      <div className="w-full max-w-xl hairline p-4 mt-12">
        <div className="text-[10px] font-mono-r tracking-[0.3em] uppercase opacity-60 mb-3 text-left">Also On</div>
        <a
          data-testid="listen-tunein-link"
          href="https://tunein.com/radio/OSO-London-s357544/"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center py-4 hover:opacity-70 transition-opacity"
          aria-label="Listen to OSO London on TuneIn"
        >
          <img
            src="/tunein-logo.png"
            alt="TuneIn"
            className="h-10 md:h-12 w-auto"
          />
        </a>
      </div>
    </section>
  );
}
